import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useDataCache } from '../contexts/DataCacheContext';
import BookingCalendar from './BookingCalendar';
import DashboardLayout from './DashboardLayout';
import configService from '../services/configService';

function Bookings() {
  const { user } = useAuth();
  const { cache, prefetchBookings } = useDataCache();
  const businessId = user?.attributes?.['custom:business_id'] || cache.settings?.businessConfig?.business_id;
  const [modules, setModules] = useState(cache.settings?.modules || {});
  const [loading, setLoading] = useState(!cache.bookings && !cache.settings);

  useEffect(() => {
    if (!cache.bookings) {
      prefetchBookings();
    }
    if (!cache.settings) {
      loadModules();
    } else {
      setModules(cache.settings.modules);
      setLoading(false);
    }
  }, [cache.bookings, cache.settings]);

  const loadModules = async () => {
    try {
      const response = await configService.getModules();
      const moduleMap = {};
      response.modules.forEach(m => {
        moduleMap[m.module_id] = m.enabled;
      });
      setModules(moduleMap);
    } catch (error) {
      console.error('Failed to load modules:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!modules.booking_system && !loading) {
    return (
      <DashboardLayout>
        <div className="text-center py-12">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Booking System Not Available</h2>
          <p className="text-gray-600">The booking system module is not enabled for your account.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="space-y-6">
          <div className="mb-6">
            <div className="text-4xl font-bold text-gray-900 mb-2">Booking Calendar</div>
            <p className="text-sm text-gray-600">View and manage your appointments.</p>
          </div>
          <BookingCalendar businessId={businessId} cachedStaff={cache.bookings?.staff} cachedServices={cache.bookings?.services} cachedBookings={cache.bookings?.bookings} />
        </div>
      )}
    </DashboardLayout>
  );
}

export default Bookings;
